import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum AppraisalRouteNames {
  APPRAISAL_TABLE = "APPRAISAL_TABLE",
  APPRAISAL_REQUEST_DETAIL = "APPRAISAL_REQUEST_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Appraisal = { appraisalId: string };
type Query = { query?: Record<string, string> };

export class AppraisalGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = AppraisalGoToHelper.locations;

    return {
      AppraisalTable: (partnerId: string) => {
        return {
          text: $t("objects.appraisal.serviceName").toString(),
          exact: true,
          to: locations.appraisalTable({ partnerId })
        };
      },
      AppraisalDetail: (partnerId: string, appraisalId: string) => {
        return {
          text: $t("common.nouns.detail").toString(),
          exact: true,
          to: locations.appraisalDetail({ partnerId, appraisalId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    appraisalTable: (d: Partner & Query) => {
      return {
        name: AppraisalRouteNames.APPRAISAL_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    appraisalDetail: (d: Partner & Appraisal & Query) => {
      return {
        name: AppraisalRouteNames.APPRAISAL_REQUEST_DETAIL,
        params: { partnerId: d.partnerId, appraisalId: d.appraisalId },
        query: d.query
      };
    }
  };

  goToAppraisalTable(d: Tab & Partner) {
    this.go(AppraisalGoToHelper.locations.appraisalTable(d), d.newTab);
  }

  goToAppraisalDetail(d: Tab & Partner & Appraisal) {
    this.go(AppraisalGoToHelper.locations.appraisalDetail(d), d.newTab);
  }
}
